import { ReactNode } from "react";

import { useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const Macros = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.macros.header",
            defaultMessage: "Macros"
        }),
        content: intl.formatMessage(
            {
                id: "ConfluencePricingPage.features.macros.content",
                defaultMessage:
                    "<p>Macros add interactivity to your Confluence pages with extra functionality or dynamic content.</p> <p>For example, use the <jiraIssuesMacros>Jira Issues macro</jiraIssuesMacros> to attach live updates of Jira issues, epics, and reports to a page. Or, use the <statusMacro>Status macro</statusMacro> to update your team on your project’s status.</p>"
            },
            {
                ...DEFAULT_VALUES,
                jiraIssuesMacros: (chunks: ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={`https://support.atlassian.com${useLocalizedHref(
                            "/confluence-cloud/docs/insert-the-jira-issues-macro/"
                        )}`}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="confluence"
                        data-track-event="ConfluencePricingPage.jiraIssuesMacros"
                        data-event-container="ConfluencePricingPage"
                    >
                        {chunks}
                    </a>
                ),
                statusMacro: (chunks: ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={`https://support.atlassian.com${useLocalizedHref(
                            "/confluence-cloud/docs/insert-the-status-macro/"
                        )}`}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="confluence"
                        data-track-event="ConfluencePricingPage.statusMacro"
                        data-event-container="ConfluencePricingPage"
                    >
                        {chunks}
                    </a>
                )
            }
        ),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.macros.altText",
            defaultMessage: "Example of macros"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.macros.caption",
            defaultMessage:
                "Here are a few sample macros in action on Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            {messages.content}
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Macros__@1x.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default Macros;
